import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class GraphqlService {

  constructor(private apollo: Apollo) {}

  getLunchMenuItemOverview() {
    return this.apollo.query({query: gql`{
      query {
        id,
        title,
        picture,
        price
      }
    }`});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/graphql.service.ts